<template>
  <div id="exportSupplies">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>

    <b-modal id="modalExport" size="xl" no-close-on-backdrop @ok="createInvoice">
      <template #modal-header="{ close }">
        <h5>สร้างใบชำระสินค้า</h5>
        <b-button size="sm" variant="outline-danger" @click="close()">
          ย้อนกลับไปเลือกรายการสั่งออก
        </b-button>
      </template>

      <template #default=" {} ">
        <b-overlay :show="!dataCreate" rounded="sm">
          <b-card>
            <b-card-body class="p-2">
              <label for="form_name" class="mb-1"><b>ชื่อผู้รับ:</b></label>
              <b-form-input id="form_name" v-model="formExport.recipientName" type="text" autocomplete="off" class="mb-2"></b-form-input>
              <label for="form_tel" class="mb-1"><b>เบอร์โทรศัพท์ผู้รับ:</b></label>
              <b-form-input id="form_tel" v-model="formExport.recipientTelephone" type="tel" autocomplete="off" class="mb-2" maxlength="10"></b-form-input>
              <label for="form_addr"><b>ที่อยู่จัดส่ง:</b> </label>
              <b-form-textarea id="form_addr" max-rows="6" class="mb-2" v-model="formExport.recipientAddress" rows="2"></b-form-textarea>

              <label for="form_paymentType" class="mb-1">
                <b>ชำระผ่านช่องทาง:</b> หักจาก <b>ยอดเงินขนส่ง <u>{{ userData.cashBalance }}</u> บาท</b>
                <!-- ธนาคารไทยพาณิชย์ 165-235662-5 นส.บุษรินทร์ อ้นแขกสุวรรณ -->

                <!-- <p>ธนาคารกสิกรไทย 027-8-24576-4 นางสาวพีรญา แสงบุญเรือง</p> -->
                <!-- <b-form-input id="form_paymentType" v-model="formExport.paymentType" type="text" autocomplete="off" class="mb-2" placeholder="ธนาคารที่โอนเงินเข้ามา"></b-form-input> -->
              </label>

              <!-- <template v-if="userData.vipName === ''">
                <b-form-checkbox
                  id="usePointBalance"
                  v-model="pointSale"
                  v-if="userData.pointBalance > 0"
                  :value="userData.pointBalance < priceTotal ? userData.pointBalance : priceTotal"
                  :unchecked-value="0"
                  switch
                >
                  ใช้แต้มส่วนลดทั้งหมด <img :src="require('@/assets/svg/chip_point.svg')" class="icon-svg"/> {{ userData.pointBalance }} แต้ม
                </b-form-checkbox>
              </template> -->

              <hr>

              <b-row>
                <b-col md="6">
                  <b-form-group label="บริษัทขนส่งสำหรับจัดส่ง:" label-class="font-weight-bolder" v-slot="{ ariaDescribedby }">
                    <b-form-radio-group v-model="radioTransportType"
                      :options="optionsTransportType" :aria-describedby="ariaDescribedby"
                      ></b-form-radio-group>

                    <!-- v-if="radioTransportType" -->
                    <b-form-input v-model="formExport.transportType"
                      type="text" autocomplete="off" class="mb-2" placeholder="กรุณากรอกบริษัทขนส่ง" v-if="radioTransportType == 'เก็บปลายทาง'"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <label for="form_remark" class="mb-1"><b>หมายเหตุ:</b></label>
                  <b-form-input id="form_remark" v-model="formExport.remark" type="text" autocomplete="off" class="mb-2" placeholder="วลีช่วยจำ, รายละเอียดพิเศษ"></b-form-input>
                </b-col>
              </b-row>

              <br>
              <p>รายการสั่งออก</p>
              <b-table striped bordered small responsive
                :items="selected" :fields="selectedFields"
                class="table-mini">

                <template #cell(price)="data">
                  {{ data.item.priceByKilo > data.item.priceByQueue ? data.item.priceByKilo : data.item.priceByQueue }}
                </template>

                <template #custom-foot=" {} ">
                  <b-tr class="font-weight-bold" v-if="selected.length >= 1">
                    <b-td colspan="4">รวม</b-td>
                    <b-td>{{ selected.map(x => parseFloat(x.amount)).reduce((a, b) => a + b) }}</b-td>
                    <b-td>{{ selected.map(x => parseFloat(x.totalWeight)).reduce((a, b) => a + b) }}</b-td>
                    <b-td>{{ selected.map(x => parseFloat(x.totalQueue)).reduce((a, b) => a + b) }}</b-td>
                    <b-td colspan="3"></b-td>
                    <b-td>{{ pricePaid }}</b-td>
                  </b-tr>
                  <!-- <b-tr v-if="pointSale > 0">
                    <b-td  colspan="10" class="text-right">ใช้แต้มส่วนลด <img :src="require('@/assets/svg/chip_point.svg')" class="icon-svg"/></b-td>
                    <b-td>-{{ pointSale }}</b-td>
                  </b-tr> -->

                  <b-tr>
                  <!-- <b-tr v-if="selected.length > 1"> -->
                    <b-td colspan="10" class="text-right">ค่าบริการโกดัง</b-td>
                    <b-td>50</b-td>
                  </b-tr>
                  <b-tr>
                    <b-td colspan="10" class="text-right"><i class="text-danger">(ราคาข้างต้นเป็นเพียงราคาประมาณการ ค่าใช้จ่ายจริงจะคิดตามบิลขนส่งและหักลบคืนเป็นยอดเงินในระบบ)</i> ค่าจัดส่งในไทย</b-td>
                    <b-td>{{ priceDelivery }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-td colspan="10" class="text-right">ราคารวมทั้งหมด</b-td>
                    <!-- <b-td>{{ pricePaid + priceDelivery - pointSale }}</b-td> -->
                    <b-td>{{ pricePaid + priceDelivery }}</b-td>
                  </b-tr>
                </template>

              </b-table>

              <hr>

              <!-- <b-row v-if="userData.vipName === ''">
                <b-col cols="4"><h5><b>แต้มที่ได้รับ</b></h5></b-col>
                <b-col cols="8" class="text-right">{{ Math.floor((priceTotal - pointSale) / 100) }} แต้ม</b-col>
              </b-row> -->

              <br>
            </b-card-body>
          </b-card>
        </b-overlay>
      </template>

      <template #modal-footer="{ ok }">
        <div class="w-100 text-right">
          <!-- <b-overlay :show="!dataCreate" rounded="sm"> -->
          <template v-if="dataCreate">
            <b v-if="!formExport.transportType" style="color: red;">กรุณาระบุบริษัทขนส่งสำหรับจัดส่ง </b>
            <b-button :disabled="!formExport.transportType" class="m-2" @click="ok()">
              <f-icon icon="dolly"></f-icon> สร้างใบชำระสินค้า
            </b-button>
          </template>
          <!-- </b-overlay> -->
          </div>
      </template>
    </b-modal>

    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">

          <left-menu :key="componentKey"></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <alert-card></alert-card>
          <h2>นำออกรหัสพัสดุ</h2>
          <b-row class="mb-3">
            <b-col sm="6" class="mb-2">
              <b-card body-class="p-0">
                <b-card-body>
                  <b-card-text>
                    <h5>จำนวนรวมรายการ: <b>{{ selected.length }} รายการ</b></h5>
                    <h5>จำนวนรวมยอดที่ต้องชำระ <b>{{ priceTotal }} บาท</b></h5>
                    <h6 v-if="userData.vipName === ''">จำนวนแต้มที่จะได้รับโดยประมาณ <img :src="require('@/assets/svg/chip_point.svg')" class="icon-svg"/> <b>{{ pointTotal }} แต้ม</b></h6>
                    <b-button :disabled="(selected.length === 0)" v-b-modal.modalExport block variant="outline-info"><f-icon icon="file-invoice-dollar"></f-icon> สร้างใบชำระสินค้า</b-button>
                  </b-card-text>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col sm="6">

              <b-card body-class="p-0">
                <b-card-body>
                  <b-form @submit="onSubmit">
                    <b-card-text>
                      <label for="form_suppliesCode" class="mb-1">รหัสพัสดุ:</label>
                      <b-input-group class="mb-2">
                        <b-form-input id="form_suppliesCode" v-model="form.suppliesCode" type="text" autocomplete="off"></b-form-input>
                        <b-input-group-append>
                          <!-- @click="getDataTracking" -->
                          <b-button variant="success" type="submit">ค้นหา</b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <b-form-checkbox v-model="form.isInThailand" name="check-in-thailand" switch value="Y" unchecked-value="">
                        แสดงเฉพาะที่ถึงไทย
                      </b-form-checkbox>
                    </b-card-text>
                  </b-form>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>

          <b-table striped bordered small
            :items="items" :fields="fields"
            :busy="!dataReady" selectable
            select-mode="multi" show-empty
            ref="selectableTable"
            selected-variant=""
            @row-selected="onRowSelected"
            empty-text="ไม่พบข้อมูล"
            class="table-mini">

            <template #head(selected)=" {} ">
              <b-form-checkbox v-model="allSelected" @change="onAllSelected">
              </b-form-checkbox>
            </template>

            <template #cell(selected)="data">
              <template v-if="data.item.InThailand">
                <template v-if="data.rowSelected">
                  <f-icon icon="check-square" class="text-success animate__animated animate__rubberBand"></f-icon>
                </template>
                <template v-else>
                  <f-icon icon="square"></f-icon>
                </template>
              </template>

              <!-- <b-form-checkbox v-model="data.item.selectData" @change="onRowSelected">
              </b-form-checkbox> -->
            </template>

            <template #cell(price)="data">
              {{ data.item.priceByKilo > data.item.priceByQueue ? data.item.priceByKilo : data.item.priceByQueue }}
            </template>

          </b-table>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "exportSupplies",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.getDataUser()
    await this.getDataTracking()
  },
  data() {
    return {
      componentKey: 1000,
      fields: [
        'selected',
        { key: 'suppliesCode', label: 'รหัสพัสดุ' },
        { key: 'userCode', label: 'รหัสสมาชิก' },
        { key: 'mnemonicPhrase', label: 'วลีช่วยจำ' },
        { key: 'category', label: 'ประเภท' },
        { key: 'InWarehouse', label: 'เข้าโกดัง' },
        { key: 'OutWarehouse', label: 'ออกโกดัง' },
        { key: 'InThailand', label: 'ถึงไทย' },
        { key: 'totalWeight', label: 'น้ำหนักรวม' },
        { key: 'totalQueue', label: 'ขนาดคิว' },
        { key: 'price', label: 'ราคา' },
      ],
      optionsTransportType: [
        { text: 'ไปรษณีย์ไทย (EMS)', value: 'ไปรษณีย์ไทย (EMS)' },
        { text: 'Kerry Express ', value: 'Kerry Express' },
        { text: 'J&T Express', value: 'J&T Express' },
        { text: 'Flash Express', value: 'Flash Express' },
        { text: 'BEST Express', value: 'BEST Express' },
        // { text: 'LALAMOVE', value: 'LALAMOVE' },

        // { text: 'ขนส่งเอกชนอื่น ๆ', value: 'อื่นๆ' }
        { text: 'รับสินค้าที่โกดัง', value: 'รับเอง' },
        { text: 'ขนส่งเอกชนเก็บเงินปลายทาง', value: 'เก็บปลายทาง' }
      ],
      radioTransportType: '',
      items: [
        // {
        //   "userName": "",
        //   "suppliesCode": "A123456",
        //   "mnemonicPhrase": "เขียวเสวย",
        //   "amount": "20",
        //   "weight": "1",
        //   "wide": "2",
        //   "high": "3",
        //   "length": "4",
        //   "category": "ไม่รู้",
        //   "InWarehouse": "2021-06-19",
        //   "OutWarehouse": "2021-06-30",
        //   "InThailand": "2021-06-30",
        //   "priceByKilo": "0",
        //   "priceByQueue": "60.2",
        //   "woodenCrate": null,
        //   "checkProduct": "",
        //   "totalWeight": null,
        //   "totalQueue": null,
        //   "remark": null,
        //   "other": null,
        //   "deliver": null
        // }
      ],
      selectedFields: [
        { key: 'suppliesCode', label: 'รหัสพัสดุ' },
        { key: 'userCode', label: 'รหัสสมาชิก' },
        { key: 'mnemonicPhrase', label: 'วลีช่วยจำ' },
        { key: 'category', label: 'ประเภท' },
        { key: 'amount', label: 'จำนวน' },
        { key: 'totalWeight', label: 'น้ำหนัก' },
        { key: 'totalQueue', label: 'คิว.' },
        { key: 'InWarehouse', label: 'เข้าโกดัง' },
        { key: 'OutWarehouse', label: 'ออกโกดัง' },
        { key: 'InThailand', label: 'ถึงไทย' },
        { key: 'price', label: 'ราคา' },
      ],
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      userData: {
        userName: '',
        userCode: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: '',
        pointBalance: 0,
        vipName: '',
        cashBalance: 0
      },
      form: {
        isInThailand: '',
        suppliesCode: '',
        userCode: ''
      },
      formExport: {
        recipientName: '',
        recipientAddress: '',
        recipientTelephone: '',
        transportType: '',

        amountPaid: '',
        amountTracking: '',
        amountDelivery: '',
        amountPoint: '',

        balanceInSystem: '',
        paymentType: 'ธนาคารไทยพาณิชย์ 165-235662-5 นส.บุษรินทร์ อ้นแขกสุวรรณ',
        remark: '',
        senderName: '',
        senderAddress: '',
        senderTelephone: '',
        status: 'รอตรวจสอบ',
        userName: '',
        userCode: '',
        CREATE_USER: '',
        suppliesCode: []
      },
      dataReady: false,
      dataCreate: true,
      allSelected: false,
      haveSender: false,
      priceTotal: 0,
      pointTotal: 0,
      pointSale: 0,
      pricePaid: 0,
      priceDelivery: 0,
    };
  },
  methods: {
    formatDate (dtDate) {
      if (dtDate) {
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0].substring(2, 4)
        return strDateShort
      } else {
        return ''
      }
    },
    onAllSelected() {
      if (this.allSelected) {
        this.$refs.selectableTable.selectAllRows()
      } else {
        this.$refs.selectableTable.clearSelected()
      }
    },
    onRowSelected(items) {
      this.selected = items.filter(dt => dt.InThailand)
      this.priceTotal = 0
      for (let i = 0; i < this.selected.length; i++) {
        // if (this.selected[i].priceByKilo) {
        //   this.priceTotal += parseFloat(this.selected[i].priceByKilo)
        // } else if (this.selected[i].priceByQueue) {
        //   this.priceTotal += parseFloat(this.selected[i].priceByQueue)
        // }
        const priceKilo = parseFloat(this.selected[i].priceByKilo) || 0
        const priceQueue = parseFloat(this.selected[i].priceByQueue) || 0
        this.priceTotal += priceKilo > priceQueue ? priceKilo : priceQueue
      }
      this.pointTotal = Math.floor(this.priceTotal / 100)
      // this.pointTotal = 0

      this.pricePaid = this.priceTotal
      this.pricePaid += 50
      // this.pricePaid += 250
      // console.log('onRowSelected this.selected: ', this.selected)
    },
    getDataUser () {
      this.dataReady = false;
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
        this.getDataProfile(lsUser.userName)
      } else {
        this.$router.push('/Login')
      }
    },


    getDataProfile(dt) {
      this.dataReady = false;
      axios
        .get(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/User/user_list?userName="+dt,
          {
            headers: this.getHeaderAPI('User_list', dt)
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            // this.form = rs.data[0]
            let data = rs.data[0]

            this.userData.cashBalance = data.cashBalance

            this.formExport.CREATE_USER = dt
            this.formExport.userName = data.userName
            this.formExport.userCode = data.userCode
            this.formExport.recipientName = data.firstName + ' ' + data.lastName
            this.formExport.recipientAddress = data.address
            this.formExport.recipientTelephone = data.telephoneNumber

            console.log('getDataProfile', this.form)
            this.dataReady = true;

            this.getDataVipUser()
          } else {
            console.log("ผิดพลาด","ไม่สามารถดึงข้อมูลส่วนตัวได้","error")
            this.dataReady = true;
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true;
          // this.errored = true
        });
    },

    getDataVipUser () {
      this.dataReady = false;
      if (this.userData.userCode) {
        axios
          .get(
            // eslint-disable-next-line quotes
            'https://licm-cargo.com/api/Vip/Vip_user?userCode=' +
            this.userData.userCode,
            {
              // headers: this.getHeaderAPI('Vip_user', this.form.userCode)
              headers: { 'application-key' : 'T2FLZ#Xo:!WJ%qnC+jPf(U&EkHDi_K8V*S(QKb)!Rcqd6XI8pOyl_unZWN2PS,E*1r=f*eL7E:4%;6y@I.)$!P_xHCnh,q3AKU#tap' }
            }
          )
          .then((response) => {
            console.log('getDataVipUser', response.data)

            let rs = response.data
            if (rs.status === true){
              this.userData.vipName = rs.data.vipName
              this.userData.pointBalance = 0
              this.dataReady = true
            }
            else {
              this.userData.vipName = ""
              this.getDataUserPoint()
            }

          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            this.$swal("ผิดพลาด", "getDataVIP error", "error")
            console.log('getDataVIP error:', error)
            this.dataReady = true
            this.dataVipReady = true
          });
      } else {
        this.$swal("ผิดพลาด", "ไม่พบรหัสสมาชิกของท่าน กรุณาติดต่อแอดมิน", "error")
      }
    },

    getDataUserPoint () {
      this.dataReady = false
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/User/User_point?userName=' +
          this.userData.userName,
          {
            headers: this.getHeaderAPI('User_point', this.userData.userName)
          }
        )
        .then((response) => {
          let rs = response.data
          console.log('getDataUserPoint Export', response.data)
          if (rs.status === true){
            this.userData.pointBalance = parseInt(rs.point)
            this.dataReady = true;
          } else {
            this.userData.pointBalance = 0
            this.dataReady = true;
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.userData.pointBalance = 0
          this.$swal("ผิดพลาด","ไม่สามารถดูแต้มส่วนลดของท่าน กรุณาติดต่อแอดมิน","error")
          this.dataReady = true;
          // this.errored = true
        });
    },

    onSubmit (event) {
      event.preventDefault()
      this.getDataTracking()
    },
    getDataTracking () {
      this.dataReady = false;
      this.totalRows = 0
      let uc = this.userData.userType === 'A' ? this.form.userCode : this.userData.userCode
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Invoice_order/Invoice_export?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          '&userCode=' +
          uc +
          '&searchInThai=' +
          this.form.isInThailand +
          '&suppliesCode=' +
          this.form.suppliesCode,
          {
            headers: this.getHeaderAPI('Invoice_export', this.userData.userName)
          }
        )
        .then((response) => {
          // console.log('getDataTracking', response.data)
          let rs = response.data
          this.items = []

          if (rs.status === true){
            if (rs.data.length > 0) {
              this.totalRows = rs.data.length

              for (let i = 0; i < rs.data.length; i++) {
                var trackingData = rs.data[i]

                // trackingData.selectData = false
                trackingData.InWarehouse = this.formatDate(rs.data[i].InWarehouse)
                trackingData.OutWarehouse = this.formatDate(rs.data[i].OutWarehouse)
                trackingData.InThailand = this.formatDate(rs.data[i].InThailand)
                // trackingData.priceTracking = parseFloat(trackingData.priceByKilo || trackingData.priceByKilo)
                this.items.push(trackingData)
              }
              console.log('getDataTracking', this.items)
              // this.items = rs.data
            }
          }

          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTracking error:', error)
          this.dataReady = true
          this.items = []
        });
    },
    createInvoice(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()

      this.dataCreate = false

      // this.formExport.amountPaid = this.pricePaid + this.priceDelivery - this.pointSale // รอแก้ปัญหาแต้ม
      this.formExport.amountPaid = this.pricePaid + this.priceDelivery

      this.formExport.amountTracking = this.priceTotal
      this.formExport.amountDelivery = this.priceDelivery
      this.formExport.amountPoint = 0
      // this.formExport.amountPoint = this.pointSale // รอแก้ปัญหาแต้ม

      if(this.radioTransportType === "เก็บปลายทาง"){
        this.formExport.transportType += " (เก็บเงินปลายทาง)"
      }

      this.formExport.suppliesCode = this.selected.map(function (obj) {
        return obj.suppliesCode
      })

      // Trigger submit handler
      this.onSubmitCreate()
    },
    onSubmitCreate() {
      // Push the name to submitted names
      this.dataCreate = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Deliver_detail/Deliver_detail_add",
          this.formExport,
          {
            headers: this.getHeaderAPI('Deliver_detail_add', this.formExport.userName)
          }
        )
        .then(async (response) => {
          console.log('onSubmit', response)
          let rs = response.data

          let footer_alert = null
          if (rs.status === true) {
            if (rs.invoice_doc) { footer_alert = '<a href="/User/Delivery?Doc=' + rs.invoice_doc + '">เปิดดูใบชำระสินค้า</a>' }
            this.$swal({
              icon: 'success',
              title: 'สร้างใบชำระสินค้าเรียบร้อย',
              html: '' +
              ' เงินในระบบของท่านคงเหลือ ' + rs.cashBalance + ' บาท',
              footer: footer_alert
            })
            this.dataCreate = true
            // Hide the modal manually
            this.$nextTick(() => {
              this.getDataTracking()
              this.getDataProfile(this.userData.userName)
              this.$bvModal.hide('modalExport')
            })
          } else {
            console.log('onSubmit Fail')
            this.$swal("ผิดพลาด","ไม่สามารถสร้างใบชำระสินค้าได้","error")
            this.dataCreate = true
          }
        })
        .catch((error) => {
          console.log(error)
          let err_resp = error.response.data
          if (err_resp.amount) {
            this.$swal({
              icon: 'error',
              title: 'ไม่สามารถสร้างใบชำระสินค้าได้',
              html: '' +
              ' เงินในระบบของท่านคงเหลือ ' + err_resp.cashBalance + ' บาท' +
              ' <br>กรุณาเติมเงินเพิ่มอีกอย่างน้อย <b style="font-size: 1.65rem;">' + (err_resp.amount) + '</b> บาท' +
              ' <br><br><a href="/User/TopUp">เติมเงิน</a>',
              // footer: footer_alert
            }).then((result) => {
              // this.$router.push('/Route?target=Export&uriType=User')
            })
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถสร้างใบชำระสินค้าได้","error")
          }
          this.dataCreate = true
        })
    }
  },
  watch: {
    radioTransportType(newValue, oldValue) {
      if(newValue === 'เก็บปลายทาง'){
        this.formExport.transportType = ''
        this.priceDelivery = 0
      } else {
        this.formExport.transportType = newValue

        if(newValue === 'รับเอง') { this.priceDelivery = 0 }
        else { this.priceDelivery = 250 }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

div.language-bar {
  padding-top: 10px;
  padding-bottom: 10px;
}

.table-mini{
  font-size: 0.85rem;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Export.vue